// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2Jemz","header":"PatientBlock_header__2mVNw","label":"PatientBlock_label__9Kpxf","option":"PatientBlock_option__3WAci"};